
import { Card, Col, Divider, Form, Input, Row, Space, Select } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import ButtonAction from 'components/Common/ButtonAction';
import { ButtonPrimary, ButtonBack, ButtonAdd, ButtonSecondary, ButtonExcel, ButtonPrint } from 'components/Common/Buttons';
import useTopbarTitleHooks from 'hooks/useTopbarTitleHooks';
import CustomAntdTable from 'components/Common/CustomAntdTable';
import { dismissToast, errorToast, successToast, loadingToastId } from 'utils/Toast';
import Constant from 'utils/Constants';
import { sorterTable } from 'utils/Helper';
import useIsMobileHooks from 'hooks/useIsMobileHooks';
import { PRIVILEGE_ID } from 'utils/AccessPermissionConfig';
import SkeletonPage from 'components/Common/SkeletonPage';
import { ButtonAdvanceFilter } from 'components/Common/ButtonAdvanceFilter';
import Error403 from 'components/Error/Error403';
import BaseAdvanceFilter from 'components/CustomDrawer/BaseAdvanceFilter';
import CellTable from 'components/Common/CellTable';
import { useNavigate, useParams } from 'react-router-dom';
import { APP_ROUTE_PREFIX, RouteConstant } from 'routes/routesConstant';
import useOrgRepo from "../../../services/repo/useOrgRepo";
import useDivisionRepo from 'services/repo/useDivisionRepo';
import useDepartmentRepo from 'services/repo/useDepartmentRepo';
import usePositionRepo from 'services/repo/usePositionRepo';
import useReportRepo from "../../../services/repo/useReportRepo";
import useDownloadReportPositionRepo from 'services/repo/useDownloadReportRepo'

export default function PositionReport() {

    useTopbarTitleHooks("Report Position/Jabatan");
    const { orgId, divId, deptId } = useParams();
    const { isLoading: isLoadingOrgList, getOrgList } = useOrgRepo(false)
    const { isLoading: isLoadingDivList, getDivisionList } = useDivisionRepo(false)
    const { isLoading: isLoadingDeptList, getDepartmentList } = useDepartmentRepo(false)
    const { isLoading: isLoadingPositionList, getPositionList } = usePositionRepo(false)
    const { isLoading: isLoadingReport, getReportPositionList } = useReportRepo(false)

    const { isLoading: isLoadingDownloadReportPosition, getDownloadExcelPositionReport } = useDownloadReportPositionRepo(false);

    const isFirstOrgInit = useRef(true);
    const isMobile = useIsMobileHooks()
    const [form] = Form.useForm()
    const navigate = useNavigate();
    const [data, setData] = useState()
    const [totalData, setTotalData] = useState(0)
    const [isOpenAdvanceFilter, setIsOpenAdvanceFilter] = useState(false)
    const isLoadingPrivilege = useRef(true)
    const hasPrivilegePage = useRef(true)
    const [isLoadedPrivilege, setIsLoadedPrivilege] = useState(false)
    const [showButtonAdd, setShowButtonAdd] = useState(false)


    const [filters, setFilters] = useState({
        orgId: null,
        divId: null,
        posId: null
    })


    const [tableParams, setTableParams] = useState({
        pageNumber: 1,
        pageSize: 10,
        filter: { ...filters },
        orderBy: "posName",
        isAscending: true
    });

    const onSearch = () => {
        const formValues = form.getFieldsValue();
        const selectedOrg = formValues.orgId;
        const orgId = selectedOrg?.value ?? selectedOrg ?? null;

        setTableParams(prev => ({
            ...prev,
            pageNumber: 1,
            filter: {
                ...filters,
                orgId: orgId,
                divId: divId,
                deptId: deptId
            }
        }));
    };

    const onSearchClick = () => {
        onSearch()
        setIsOpenAdvanceFilter(false)
    }


    const fetchData = async () => {

        const payload = {
            ...tableParams,
            filter: {
                ...tableParams.filter,
                orgId: orgId,
                divId: divId,
                deptId: deptId
            }
        }
        const res = await getReportPositionList(payload)
        console.log(JSON.stringify(res))
        if (res?.detail == 'OK' && res?.status === 200) {
            setData(res?.data?.content)
            setTotalData(res?.data?.totalElements)
        }
    };

    const handleTableChange = (pagination, filters, sorter) => {
        setTableParams(prevParams => ({
            ...prevParams,
            pageNumber: pagination?.current,
            pageSize: pagination?.pageSize,
            orderBy: sorter?.field || prevParams?.orderBy,
            isAscending: sorterTable(sorter?.order, prevParams?.isAscending)
        }));
        if (pagination.pageSize !== tableParams?.pageSize) {
            setData([]);
        }
    };


    const handleView = async (data) => {
        const key = 'loadingEdit';
        loadingToastId(Constant.message.loading, key)
        navigate(APP_ROUTE_PREFIX + "/" + RouteConstant.organization.division.edit(data?.divId));
        dismissToast(key)
    }

    const handleExport = async () => {
        const key = "loadingExportPosition";
        loadingToastId("Exporting file...", key);

        try {
            // Ambil dari form
            const formOrg = form.getFieldValue("orgId");   // {label,value} atau number/null
            const formDiv = form.getFieldValue("divId");   // number/null
            const formDept = form.getFieldValue("deptId");  // number/null
            const formPos = form.getFieldValue("posId");   // number/null

            // Resolve dengan fallback: form -> tableParams.filter -> filters -> URL params
            const resolvedOrgId = (formOrg?.value ?? formOrg ?? tableParams?.filter?.orgId ?? filters?.orgId ?? orgId) || null;
            const resolvedDivId = (formDiv ?? tableParams?.filter?.divId ?? filters?.divId ?? divId) ?? null;
            const resolvedDeptId = (formDept ?? tableParams?.filter?.deptId ?? filters?.deptId ?? deptId) ?? null;
            const resolvedPosId = (formPos ?? tableParams?.filter?.posId ?? filters?.posId) ?? null;

            // Validasi — di halaman Position sebaiknya semua wajib
            if (!resolvedOrgId) { dismissToast(key); return errorToast("Please select Organization first."); }
            if (!resolvedDivId) { dismissToast(key); return errorToast("Please select Division first."); }
            if (!resolvedDeptId) { dismissToast(key); return errorToast("Please select Department first."); }
            if (!resolvedPosId) { dismissToast(key); return errorToast("Please select Position first."); }

            // Panggil repo (axios sudah responseType: 'blob')
            const response = await getDownloadExcelPositionReport({
                orgId: Number(resolvedOrgId),
                divId: Number(resolvedDivId),
                deptId: Number(resolvedDeptId),
                posId: Number(resolvedPosId),
            });

            // Deteksi JSON error yang dikirim sebagai blob
            const contentType = response?.headers?.["content-type"] || response?.headers?.get?.("content-type");
            if (contentType && contentType.includes("application/json")) {
                const text = await response.data.text?.();
                try {
                    const json = JSON.parse(text || "{}");
                    throw new Error(json?.message || "Export failed.");
                } catch {
                    throw new Error("Export failed.");
                }
            }

            // Nama file dari Content-Disposition atau fallback timestamp
            const dispo = response?.headers?.["content-disposition"] || response?.headers?.get?.("content-disposition");
            let fileName = `${getCurrentDateTime()}-Report Organization(Position).xlsx`;
            if (dispo) {
                const match = dispo.match(/filename\*=UTF-8''(.+)|filename="?([^"]+)"?/i);
                if (match) fileName = decodeURIComponent(match[1] || match[2]);
            }

            // Buat blob & trigger download
            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.setAttribute("download", fileName);
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);

            dismissToast(key);
            successToast("File successfully downloaded.");
        } catch (err) {
            dismissToast(key);
            errorToast(err?.message || "Export failed.");
        }
    };

    const getCurrentDateTime = () => {
        const now = new Date();
        const y = now.getFullYear();
        const m = String(now.getMonth() + 1).padStart(2, '0');
        const d = String(now.getDate()).padStart(2, '0');
        const hh = String(now.getHours()).padStart(2, '0');
        const mm = String(now.getMinutes()).padStart(2, '0');
        const ss = String(now.getSeconds()).padStart(2, '0');
        return `${y}${m}${d}${hh}${mm}${ss}`;
    };


    const fetchCheckPrivilege = async () => {
        setShowButtonAdd(false)
        isLoadingPrivilege.current = false
        hasPrivilegePage.current = true;
        setIsLoadedPrivilege(true)
        // await fetchData();
        dismissToast(PRIVILEGE_ID.AddEditDivision);
    }

    // Org dropdown
    const [orgOptions, setOrgOptions] = useState([])
    const fetchDataOrg = async () => {
        const payload = {
            pageNumber: 1,
            pageSize: 0,
            orderBy: "orgId",
            isAscending: true,
            filter: {
                ...filters
            }
        };
        const res = await getOrgList(payload);

        if (res?.detail === 'OK' && res?.status === 200) {
            const options = res.data.content.map(item => ({
                label: item?.orgName,
                value: item?.orgId,
            }));

            setOrgOptions(options);

            if (options.length === 1) {
                const onlyOption = options[0];

                form.setFieldsValue({ orgId: onlyOption }); // isinya harus { label, value }
                setFilters((prev) => ({ ...prev, orgId: onlyOption.value }));

                setTableParams((prev) => ({
                    ...prev,
                    filter: {
                        ...prev.filter,
                        orgId: onlyOption.value
                    }
                }));

                fetchDataDivision(onlyOption.value);
            }
        }
    };


    const [divOptions, setDivOptions] = useState([])
    const fetchDataDivision = async (orgId) => {
        console.log("🚀 Calling fetchDataDivision with orgId:", orgId); // ⬅ ini wajib muncul

        const payload = {
            pageNumber: 1,
            pageSize: 0,
            filter: {
                divCode: "",
                divName: "",
                orgId: orgId,
                divId: null,
                status: "true",
            },
            orderBy: "divCode",
            isAscending: true
        }
        setDivOptions([])

        const res = await getDivisionList(payload)
        if (res?.detail == 'OK' && res?.status === 200) {
            const options = res?.data?.content.map(item => ({
                value: item?.divId,
                label: item?.divName
            }));

            setDivOptions(options);

            // Auto-select jika hanya ada satu opsi atau ada divId dari URL
            if (options.length === 1) {
                const onlyOption = options[0];
                form.setFieldsValue({ divId: onlyOption.value });
                setFilters((prev) => ({ ...prev, divId: onlyOption.value }));
            } else if (divId) {
                form.setFieldsValue({ divId: divId });
                setFilters((prev) => ({ ...prev, divId: divId }));
            }
        }
    }

    const [deptOptions, setDeptOptions] = useState([]);
    const fetchDataDepartment = async (divId) => {
        const payload = {
            pageNumber: 1,
            pageSize: 0,
            filter: {
                deptCode: "",
                deptName: "",
                divId: divId,
                status: "true"
            },
            orderBy: "deptCode",
            isAscending: true
        };

        const res = await getDepartmentList(payload);

        if (res?.status === 200 && res?.detail === 'OK') {
            const options = res.data.content.map(item => ({
                label: item.deptName,
                value: item.deptId
            }));
            setDeptOptions(options);

            // Auto select jika hanya satu
            if (options.length === 1) {
                const onlyOption = options[0];
                form.setFieldsValue({ deptId: onlyOption.value });
            }
        }
    };

    const [positionOptions, setPositionOptions] = useState([]);
    const fetchDataPosition = async (deptId) => {
        const payload = {
            pageNumber: 1,
            pageSize: 0,
            filter: {
                deptId: deptId,
                status: "true"
            },
            orderBy: "posName",
            isAscending: true
        };

        const res = await getPositionList(payload);

        if (res?.status === 200 && res?.detail === 'OK') {
            const options = res.data.content.map(item => ({
                label: item.posName,
                value: item.posId
            }));
            setPositionOptions(options);

            // Auto-select jika hanya satu
            if (options.length === 1) {
                const onlyOption = options[0];
                form.setFieldsValue({ posId: onlyOption.value });
            }
        }
    };



    useEffect(() => {
        fetchCheckPrivilege()
    }, [])


    useEffect(() => {

        if (isLoadedPrivilege) {
            fetchData();
        }

        fetchDataOrg();
        fetchDataDivision();
    }, [JSON.stringify(tableParams)]);

    useEffect(() => {
        const timeOutId = setTimeout(() => {
            if (isLoadedPrivilege && !isMobile) {
                onSearch()
            }
        }, Constant.delayFilter);
        return () => clearTimeout(timeOutId);
    }, [filters]);

    useEffect(() => {
        if (divId) {
            fetchDataDepartment(divId);
        }
    }, [divId]);

    useEffect(() => {
        if (deptId) {
            fetchDataPosition(deptId);
        }
    }, [deptId]);


    const filterUI = () => {
        return (
            <Form
                layout="horizontal"
                form={form}
            >
                <Row gutter={16}>
                    <Col xs={24} sm={10} md={8}>
                        <Form.Item name='orgId' label="Organization" labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}>
                            <Select
                                style={{ width: '100%' }}
                                allowClear
                                showSearch
                                placeholder='Select Organization'
                                loading={isLoadingOrgList}
                                options={orgOptions}
                                onChange={(selectedValue) => {
                                    const orgId = selectedValue ?? null;
                                    form.setFieldsValue({ orgId: orgId });
                                    setTableParams((prev) => ({
                                        ...prev,
                                        pageNumber: 1,
                                        filter: {
                                            ...prev.filter,
                                            orgId: orgId
                                        }
                                    }));
                                }}
                                filterOption={(input, option) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                            />
                        </Form.Item>

                        <Form.Item name="divId" label="Division"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}>
                            <Select
                                style={{ width: '100%' }}
                                allowClear
                                showSearch
                                placeholder="Select Division"
                                loading={isLoadingDivList}
                                disabled={true}
                                options={divOptions}
                                onChange={(value) => {
                                    setFilters((prev) => ({
                                        ...prev,
                                        divId: value || null,
                                    }));
                                    form.setFieldsValue({ deptId: undefined }); // reset dept
                                    if (value) fetchDataDepartment(value); // Fetch Dept
                                }}

                            />
                        </Form.Item>

                        <Form.Item
                            name="deptId"
                            label="Department"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                            rules={[
                                {
                                    required: true,
                                    message: "Please select a department",
                                },
                            ]}
                        >
                            <Select
                                showSearch
                                placeholder="Select Department"
                                allowClear
                                style={{ width: '100%' }}
                                options={deptOptions}
                                onChange={(value) => {
                                    setFilters((prev) => ({ ...prev, deptId: value || null }));
                                    if (value) fetchDataPosition(value);
                                    form.setFieldsValue({ posId: undefined }); // Reset posisi
                                }}

                                filterOption={(input, option) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                            />
                        </Form.Item>


                        <Form.Item
                            name="posId"
                            label="Posisi"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                            rules={[
                                {
                                    required: true,
                                    message: "Please select a position",
                                },
                            ]}
                        >
                            <Select
                                showSearch
                                placeholder="Select Position"
                                allowClear
                                style={{ width: '100%' }}
                                options={positionOptions}
                                filterOption={(input, option) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                            />
                        </Form.Item>

                    </Col>

                    <Col xs={24} sm={24} md={12}>

                    </Col>

                </Row>
            </Form>
        )
    }

    const columns = [
        {
            title: 'Posisi',
            dataIndex: 'posName',
            sorter: true,
            width: "200px",
            render: (data) => <CellTable data={data} />
        },
        {
            title: 'FTE',
            dataIndex: 'wbsContentFte',
            width: "125px",
            sorter: true,
            render: (data) => <CellTable data={data} />
        },
        {
            title: 'Jumlah SDM',
            dataIndex: 'resourceTotal',
            width: "150px",
            sorter: true,
            render: (data) => <CellTable data={data} />
        },
        {
            title: 'Jumlah SDM Direkomendasikan',
            dataIndex: 'resourceTotalRecommendation',
            width: "200px",
            sorter: true,
            render: (data) => <CellTable data={data} />
        },
        {
            title: 'Gap',
            dataIndex: 'resourceTotalGap',
            width: "120px",
            sorter: true,
            render: (data) => <CellTable data={data} />
        }
    ];
    return (
        <>
            {hasPrivilegePage.current ?
                <Space direction="vertical" size="large" className='space-vertical-flex'>
                    <Card size="big" bordered={false}>
                        {isLoadingPrivilege.current ? <SkeletonPage /> :
                            <>
                                <Row gutter={[16, 16]}>
                                    <Col xs={24} sm={20} xl={18}>
                                        {/* {showButtonAdd && <ButtonAdd onClick={handleAdd} />} */}
                                    </Col>
                                </Row>
                                <Divider dashed className='mb-1 mt-1' />

                                {isMobile ?
                                    <ButtonAdvanceFilter onClick={() => setIsOpenAdvanceFilter(true)} />
                                    :

                                    (
                                        <>
                                            {filterUI()}

                                        </>)
                                }

                                <CustomAntdTable
                                    columns={columns}
                                    dataSource={data}
                                    rowKey={"divId"}
                                    tableParam={tableParams}
                                    totalData={totalData}
                                    // loading={isLoadingList}
                                    onChange={handleTableChange}
                                // rowClick={handleRowClick}
                                // isOpenDrawer={isOpenDrawer}
                                // idDataHighlight={idHighlightRow}
                                />

                                <Space className="mb-2">
                                    <div>

                                    </div>
                                </Space>

                                <Col span={24} offset={10}>
                                    <div style={{ display: "flex", gap: "10px" }}>
                                        <ButtonBack onClick={() => navigate(APP_ROUTE_PREFIX + '/' + RouteConstant.report.reportDepartment(orgId, divId, deptId))} />
                                         <ButtonExcel buttonText="Download" onClick={handleExport} />
                                        
                                    </div>
                                </Col>
                            </>
                        }
                    </Card>
                </Space> : (<Error403 />)
            }

            {isOpenAdvanceFilter &&
                <BaseAdvanceFilter
                    onClose={() => setIsOpenAdvanceFilter(false)}
                    onSearchClick={onSearchClick}>
                    {filterUI()}
                </BaseAdvanceFilter>}
        </>
    )
}
